import React from "react";
import { isProdHost, upsertMeta } from "./Seo";
/**
 * Глобальный «пояс безопасности»: на не-прод хостах (staging, localhost)
 * ставит noindex для ВСЕХ страниц — в т.ч. тех, что не рендерят <Seo>.
 * Рендерится один раз в корне (index.tsx). Императивно (без helmet).
 *
 * ВНИМАНИЕ: это JS-мета, её видит только Google. Яндекс и боты соцсетей JS не
 * исполняют, поэтому staging от них надо закрывать НА СЕРВЕРЕ (nginx:
 * `add_header X-Robots-Tag "noindex, nofollow";` или отдельный robots.txt).
 * См. docs/SEO.md.
 */
export const StagingNoindex = () => {
    React.useEffect(() => {
        if (!isProdHost()) {
            upsertMeta("name", "robots", "noindex, nofollow");
        }
    }, []);
    return null;
};
export default StagingNoindex;
